import { render, staticRenderFns } from "./SetupStep2.vue?vue&type=template&id=59c4a86c"
import script from "./SetupStep2.vue?vue&type=script&lang=js"
export * from "./SetupStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports